import MarkerWithInfoWindow from './MarkerWithInfoWindow';

export default MarkerWithInfoWindow;
